<!-- close button -->
<input type="text" autofocus hidden>
<div class="modal-header pb-0 px-mobile-8px ">
  <button class="glo-btn-close close m-0 p-0 ml-auto" title="Close" (click)="activeModal.dismiss('Cross click')">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
      <use href="assets/sprite.view.svg#glo-close-2"></use>
    </svg>
  </button>
</div>

<!-- modal titles and inputs -->
<div class="save-progress modal-body pt-0 pb-0" [ngSwitch]="currentFormType">
  <!-- login title -->
  <div *ngSwitchCase="formTypeEnum.Login" class="mb-4">
    <div class="title-2 mb-4 mb-md-9">Sign in</div>
    <div class="content-3">Enter your email and password.</div>
    <p class="text-danger mt-2 glo-size-14 mb-0" *ngIf="accountProcessingError">{{ accountProcessingError }}</p>
  </div>
  
  <!-- forgot pass title -->
  <div *ngSwitchCase="formTypeEnum.ForgotPassword" class="mb-4">
    <div class="title-2 mb-4 mb-md-9">Forgot password</div>
    <div class="content-3">Enter your email address to recover your password.</div>
  </div>

  <!-- save button click title -->
  <div *ngSwitchCase="formTypeEnum.SaveYourWork">
    <div>
      <div class="title-2 mb-4 mb-md-9">Save your progress</div>
      <div class="content-3 mb-5 mb-md-9">Pick up where you left off by creating an account.</div>
    </div>
  </div>

  <!-- logo click title -->
  <div *ngSwitchCase="formTypeEnum.LZLogoSaveYourProgress">
    <h2 class="title-2 mb-4 mb-md-9">Save your progress before you go</h2>
    <p class="content-3 mb-5 mb-md-9">Not ready to finish your order? Create an account and we'll save your progress so you can resume anytime.</p>
  </div>

  <!-- form for everything but logo click -->
  <form [formGroup]="form" id="sypForm" *ngIf="currentFormType !== formTypeEnum.LZLogoSaveYourProgress" novalidate>

    <!-- email field -->
    <p class="form form-input" [ngClass]="{'not-empty': form?.controls?.email?.value?.toString().trim().length > 0}">
      <input id="guestExistingUserEmail" name="guestExistingUserEmail" formControlName="email" type="text" required
        class="form-control" (keydown.enter)="currentFormType == formTypeEnum.ForgotPassword ? forgotPassword() : ''">
      <label for="guestExistingUserEmail"><span>Email address</span></label>
      <span *ngIf="form?.controls?.email?.errors?.required && form?.controls?.email?.touched"
        class="invalid-feedback">Email is required.</span>
      <span
        *ngIf="(form?.controls?.email?.errors?.email || form?.controls?.email?.errors?.invalidEmail) && form?.controls?.email?.touched"
        class="invalid-feedback">Enter a valid email.</span>
    </p>

    <!-- password field -->
    <p class="form form-input form-svg mt-2" *ngIf="currentFormType !== formTypeEnum.ForgotPassword"  [ngClass]="{'not-empty': form?.controls?.password?.value?.toString().trim().length > 0}">
      <input id="password" name="password" formControlName="password" type="{{passwordViewType}}" required class="form-control" minlength="6"
      (keydown.enter)="currentFormType == formTypeEnum.Login ? signIn() : createMyAccount()">
      <label for="password"><span>Password</span></label>
      <span *ngIf="form.controls.password.errors?.required && form.controls.password.touched"
        class="invalid-feedback">Password is required.</span>
      <span *ngIf="form.controls.password.errors?.minlength && form.controls.password.touched"
        class="invalid-feedback">Must be at least 6 characters.</span>
      <button class="form-svg eyeball-button" type="button" title="toggle password visibility" (click)="togglePasswordVisibility()">
        <svg width="25" height="14" xmlns="http://www.w3.org/2000/svg" *ngIf="! isPasswordVisible" style="margin-top:3px;"><path d="M12 10.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7m0 1a4.5 4.5 0 100-9 4.5 4.5 0 000 9m0 2.5C5.373 14 0 7 0 7s5.373-7 12-7 12 7 12 7-5.373 7-12 7m10.323-7.415a23.134 23.134 0 00-2.466-2.306C17.305 2.221 14.633 1 12 1S6.695 2.221 4.142 4.279A23.315 23.315 0 001.303 7a23.315 23.315 0 002.839 2.721C6.695 11.778 9.367 13 12 13s5.305-1.222 7.857-3.279A23.134 23.134 0 0022.697 7a22.625 22.625 0 00-.374-.415" fill="#000" fill-rule="evenodd"/></svg>
        <svg width="25" height="20" xmlns="http://www.w3.org/2000/svg" *ngIf="isPasswordVisible"><path d="M21.218.333l.707.707L3.729 19.236l-.707-.707L21.218.333zM14.485 5.57l-.442.897a3.5 3.5 0 00-4.738 4.574l-.913.41a4.5 4.5 0 016.093-5.88zm8.338 4.454c.133-.144.258-.282.374-.414a23.217 23.217 0 00-2.839-2.721 19.81 19.81 0 00-1.164-.872l.569-.823C22.642 7.188 24.5 9.61 24.5 9.61s-5.373 7-12 7c-1.288 0-2.529-.265-3.693-.69l.8-.784a9.452 9.452 0 002.893.474c2.633 0 5.305-1.222 7.858-3.279.91-.733 1.738-1.52 2.465-2.307zM2.177 9.194c-.133.144-.258.283-.374.415a23.315 23.315 0 002.839 2.721c.545.44 1.104.846 1.674 1.212l-.541.841C2.592 12.334.5 9.61.5 9.61s5.373-7 12-7c1.425 0 2.791.324 4.06.831l-.767.778c-1.108-.4-2.208-.609-3.293-.609-2.633 0-5.304 1.221-7.858 3.28a23.413 23.413 0 00-2.465 2.305zm8.348 4.242l.369-.93a3.5 3.5 0 004.644-4.259l.958-.287a4.5 4.5 0 01-5.971 5.476z" fill="#000" fill-rule="evenodd"/></svg>
      </button>
    </p>

    <!-- forgot password for login form -->
    <div *ngIf="currentFormType === formTypeEnum.Login" class="mt-2 mb-0">
      <a class="glo-link-action-plain glo-link-action-plain glo-size-16" href="javascript:" (click)="changeFormType(formTypeEnum.ForgotPassword)">Forgot password?</a>
      <div *ngIf="clickedForgotPassword" class="caption-1 mt-9">You will receive an email with instructions to reset your password. If you don't receive this email within 15 minutes, check your junk mail and spam folders. If you still have problems, call our customer care team at (800) 773-0888 M-F from 5 a.m.-7 p.m. PT.</div>
    </div>
  </form>


<!-- ctas and links -->
<ng-container *ngIf="currentFormType !== formTypeEnum.LZLogoSaveYourProgress; else LZLogoSaveYourProgressForm">
  <div class="save-progress pt-0 pb-1 d-block">
    <!-- login copy -->
    <p *ngIf="currentFormType === formTypeEnum.SaveYourWork" class="caption-1 mt-2">By clicking the button, I agree to the
      <a class="glo-link-action glo-size-14" href="https://www.legalzoom.com/legal/general-terms/privacy-policy"
        target="_blank">Privacy Policy</a> and
      <a class="glo-link-action glo-size-14" href="https://www.legalzoom.com/legal/general-terms/terms-of-use"
        target="_blank">Terms of Use</a>.
    </p>

    <div [ngSwitch]="currentFormType" class="m-0">

      <!-- login ctas and links -->
      <div *ngSwitchCase="formTypeEnum.Login">
        <button type="button" id="btn-sign-in" class="btn btn-action btn-sign-in mt-5 mt-md-9 mb-9" [class.glo-btn-loading]="isLoading" (click)="signIn()">
          <span *ngIf="isLoading">
            Signing in...
          </span>
          <span *ngIf="!isLoading">
            Sign in
          </span>
        </button>
        <div class="glo-size-16 mb-6">
          New user? <a class="glo-link-action-plain glo-link-action-plain" href="javascript:" (click)="openForm(formTypeEnum.SaveYourWork)">Create an account</a>
        </div>
      </div>

      <!-- save button ctas and links -->
      <div class="mt-5 mt-md-9" *ngSwitchCase="formTypeEnum.SaveYourWork">
        <button type="button" id="btn-create-account" class="btn btn-action btn-create-account" (click)="createMyAccount()" [class.glo-btn-loading]="isLoading" >
          <span *ngIf="isLoading">
            Creating account...
          </span>
          <span *ngIf="!isLoading">
            Create account
          </span>
        </button>
        <div class="mt-9 mb-6">
          <span class="content-3">Already have an account? <a href="javascript:"
              class="glo-link-action-plain glo-size-16" (click)="changeFormType(formTypeEnum.Login)">Sign in</a></span>
        </div>
      </div>

      <!-- forgot password ctas and links -->
      <div class="mt-4 mt-md-2" *ngSwitchCase="formTypeEnum.ForgotPassword">
        <button type="button" id="btn-forgot-password" class="btn btn-action btn-forgot-password" (click)="forgotPassword()" [class.glo-btn-loading]="isLoading">
          <span *ngIf="isLoading">
            Resetting password...
          </span>
          <span *ngIf="!isLoading">
            Send password reset
          </span>
        </button>
        <div class="mt-9 mb-6">
          <span class="content-3">Know your password? <a href="javascript:"
              class="glo-link-action-plain" (click)="changeFormType(formTypeEnum.Login)">Sign in</a></span>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- logo click ctas and links -->
<ng-template [ngSwitch]="currentFormType">
  <div class="save-progress pt-0 pb-1 d-block"
    *ngIf="currentFormType === formTypeEnum.LZLogoSaveYourProgress">
    <div class="mb-9">
      <button type="button" class="btn btn-action mb-4 mb-md-0" (click)="openForm(formTypeEnum.SaveYourWork)">
        <span>
          Create account
        </span>
      </button>
      <button type="button" class="btn btn-outline btn-outline-primary" (click)="openForm(formTypeEnum.Login)">
        <span>
          Sign in
        </span>
        <span *ngIf="!isLoading">
          Create account
        </span>
      </button>
      <p>Already have an account?
        <a href="javascript:" (click)="changeFormType(formTypeEnum.Login)">Sign in</a>.
      </p>
    </div>
    <button type="button" id="btn-forgot-password" class="btn btn-primary btn-sm" (click)="forgotPassword()">
      <span *ngIf="isLoading">
        <i class="fa fa-spinner fa-pulse fa-fw"></i>
      </span>
      <span *ngIf="!isLoading">
        Send password reset
      </span>
    </button>
  </div>
</ng-template>

<!-- save your progress 3 button modal -->
<ng-template #LZLogoSaveYourProgressForm>
  <div class="save-progress pt-0 pb-1 d-block"
    *ngIf="currentFormType === formTypeEnum.LZLogoSaveYourProgress">
    <div class="mb-9">
      <button type="button" class="btn btn-action mb-mobile-24px mr-md-4" (click)="openForm(formTypeEnum.SaveYourWork)">
        <span>
          Create account
        </span>
      </button>
      <button type="button" class="btn btn-outline-action" (click)="openForm(formTypeEnum.Login)">
        <span>
          Sign in
        </span>
      </button>
    </div>
    <div class="mbc-72 text-center text-md-left">
      <p class="glo-size-16" (click)="gotoHomePage()"><a href="javascript:" class="glo-link-action-plain">Leave without saving</a></p>
    </div>
  </div>
</ng-template>

</div>
